/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 1.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { CorrespondenceRequest } from '../models';
import { CorrespondenceViewIEnumerableResponse } from '../models';
/**
 * CorrespondenceApi - axios parameter creator
 * @export
 */
export const CorrespondenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v1/Correspondence/GetCorrespondenceByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet: async (correspondenceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'correspondenceId' is not null or undefined
            if (correspondenceId === null || correspondenceId === undefined) {
                throw new RequiredError('correspondenceId','Required parameter correspondenceId was null or undefined when calling apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet.');
            }
            const localVarPath = `/api/v1/Correspondence/GetFileStreamByCorrespondenceId/{correspondenceId}`
                .replace(`{${"correspondenceId"}}`, encodeURIComponent(String(correspondenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CorrespondenceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CorrespondenceSaveCorrespondencePost: async (body?: CorrespondenceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/Correspondence/SaveCorrespondence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CorrespondenceApi - functional programming interface
 * @export
 */
export const CorrespondenceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorrespondenceViewIEnumerableResponse>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {CorrespondenceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CorrespondenceSaveCorrespondencePost(body?: CorrespondenceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await CorrespondenceApiAxiosParamCreator(configuration).apiV1CorrespondenceSaveCorrespondencePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CorrespondenceApi - factory interface
 * @export
 */
export const CorrespondenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<CorrespondenceViewIEnumerableResponse> {
            return CorrespondenceApiFp(configuration).apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} correspondenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any): AxiosPromise<string> {
            return CorrespondenceApiFp(configuration).apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CorrespondenceRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CorrespondenceSaveCorrespondencePost(body?: CorrespondenceRequest, options?: any): AxiosPromise<BooleanResponse> {
            return CorrespondenceApiFp(configuration).apiV1CorrespondenceSaveCorrespondencePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CorrespondenceApi - object-oriented interface
 * @export
 * @class CorrespondenceApi
 * @extends {BaseAPI}
 */
export class CorrespondenceApi extends BaseAPI {
    /**
     * 
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV1CorrespondenceGetCorrespondenceByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {number} correspondenceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId: number, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV1CorrespondenceGetFileStreamByCorrespondenceIdCorrespondenceIdGet(correspondenceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {CorrespondenceRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorrespondenceApi
     */
    public apiV1CorrespondenceSaveCorrespondencePost(body?: CorrespondenceRequest, options?: any) {
        return CorrespondenceApiFp(this.configuration).apiV1CorrespondenceSaveCorrespondencePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
